var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "user-c-frame",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.14,
    height: 21.14,
    viewBox: "0 0 21.14 21.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_102",
    "data-name": "Ellipse 102",
    cx: 3.303,
    cy: 3.303,
    r: 3.303,
    transform: "translate(7.267 5.285)",
    fill: "#19AF8B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_360",
    "data-name": "Path 360",
    d: "M9.5,10a6.591,6.591,0,0,0-6.153,4.249,9.209,9.209,0,0,0,12.306,0A6.594,6.594,0,0,0,9.5,10Z",
    transform: "translate(1.074 3.212)",
    fill: "#19AF8B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_361",
    "data-name": "Path 361",
    d: "M10.57,21.14A10.57,10.57,0,1,1,21.14,10.57,10.582,10.582,0,0,1,10.57,21.14Zm0-18.5A7.927,7.927,0,1,0,18.5,10.57,7.935,7.935,0,0,0,10.57,2.642Z",
    fill: "#19AF8B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.d28dc070b65f99c5b5228a82dd58558f.svg";
export { ForwardRef as ReactComponent };